export default "__VITE_ASSET__C1EqyW_i__"